export default (ctx, inject) => {
  inject('mask', {
    alphabetic: {
      mask: /^([a-zA-Z]([\s]{0,1})){0,50}$/,
    },
    alphanumeric: {
      mask: /^([\u0400-\u04FF-a-z0-9A-Z]([\s]{0,1})){0,50}$/,
    },
    alphanumeric100: {
      mask: /^([\u0400-\u04FF-a-z0-9A-Z]([\s]{0,1})){0,100}$/,
    },
    alphabeticCyrillic: {
      mask: /^([\u0400-\u04FF-]([\s]{0,1})){0,50}$/,
    },
    alphabeticCyrillic30: {
      mask: /^([\u0400-\u04FF-]([\s]{0,1})){0,30}$/,
    },
    alphanumericCyrillic: {
      mask: /^([\u0400-\u04FF-0-9]([\s]{0,1})){0,50}$/,
    },
    phone: {
      mask: '# (%00) 000-000',
      lazy: false,
      definitions: {
        '#': /0/,
        '%': /[1-9]/,
      },
    },
    recoverPhone: {
      mask: '000000000',
      lazy: false,
    },
    personalId: {
      mask: /^\d{0,14}$/,
    },
    password: {
      mask: /([a-zA-Z0-9!@#=%$><&§°~*()\\.+,/-])$/,
    },
    cyrillic: {
      mask: /([\u0400-\u04FF-]([\s]{0,1}))$/,
    },
    emailWithoutCyrillic: {
      mask: /[^\u0400-\u04FF]$/,
    },
    number: {
      mask: Number,
      min: 0,
    },
    date: {
      mask: Date,
      pattern: 'd{.}m{.}Y',
      max: new Date(),
    },
    eWallet: {
      mask: /^([0-9]){0,10}$/,
    },
    smsCode: {
      mask: /^([0-9]){0,4}$/,
    },
    socialFundOtpCode: {
      mask: /^([0-9]){0,6}$/,
    },
    passportNumber: {
      mask: '{00}#######',
      definitions: {
        '0': /^([\u0400-\u04FF-a-zA-Z])$/,
        '#': Number,
      },
      prepare: val => val.toUpperCase(),
    },
    houseNr: {
      mask: /^([\u0400-\u04FF-0-9]|([\s]{0,0})){0,5}$/,
    },
    bankAccount: {
      mask: /^1(\d){0,15}$/,
    },
    financeRangeMask: {
      mask: Number,
      min: 0,
      max: 9999999999999.99,
    },
    emailCode: {
      mask: '00000',
    },
    fullName: {
      mask: /^([\u0400-\u04FF-ҢңҮүӨө)](\s?)){0,30}$/,
    },
    additionalIncomeRangeMask: {
      mask: Number,
      min: 0,
      max: 250000,
    },
  });
};
